import choVayConst from "constants/choVayConst";
import { LaiSuatText } from "constants/choVayConst";
import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import NhanVayApi from "service/nhanVayApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

export const ThongTinChoVay = ({ hopdong }) => {
  return (
    <>
      <div className="select-thongtinvay">
        <div className="row">
          <div className="col-md-4 col-lg-4">
            <div className="from-thongtinvay">
              <p>Số tiền vay:</p>
              <p>
                <span className="red">{formatNumber(hopdong.Sotienvay)}</span>{" "}
                (vnđ)
              </p>
              <p>Ngày vay: {getDate(hopdong.NgayVay)}</p>
            </div>
          </div>
          <div className="col-md-4 col-lg-4">
            <div className="from-thongtinvay">
              <p>Ngày bắt đầu trả lãi: {getDate(hopdong.NgayVay)}</p>
              <p>
                Kiểu đóng lãi:{" "}
                {choVayConst.BeforeAfterText[hopdong.BeforeAfter]}
              </p>
              <p>
                Kỳ đóng lãi: {hopdong.CountTypePaid}{" "}
                {hopdong.TypePaid === 1 ? "ngày" : "tháng"} đóng 1 lần | trả
                theo {hopdong.TypePaid === 1 ? "ngày" : "tháng"}
              </p>
              <p>
                Lãi suất: {choVayConst.KieuLaiSuatText[hopdong.KieuLaiSuat]}:{" "}
               {hopdong.LaiSuat}
              </p>
              <p>Số lần trả: {hopdong.SoLanTra} Lần</p>
              <p>Ngày tất toán: {getDate(hopdong.NgayTra)}</p>
            </div>
          </div>
          <div className="col-md-4 col-lg-4">
            <div className="from-thongtinvay">
              <p>Thời gian tạo: {hopdong.NgayTao}</p>
              <p>Người tạo hợp đồng: {hopdong.NguoiTao}</p>
            </div>
          </div>
          <div className="col-md-12 col-lg-12">
            <div className="from-notevay">
              <p>Ghi chú: {hopdong.GhiChu}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
